module.exports = __webpack_public_path__ + "assets/img/WechatIMG60.e16b153f.png";